import { render, staticRenderFns } from "./PhaseForm.vue?vue&type=template&id=b2dab11e&"
import script from "./PhaseForm.vue?vue&type=script&lang=js&"
export * from "./PhaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports